import { useState } from "react";
import {
  FaUser,
  FaEnvelope,
  FaPhoneAlt,
  FaPaperPlane,
  FaMapMarkerAlt,
  FaClock,
  FaWhatsapp,
} from "react-icons/fa";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="min-h-screen bg-canvas pb-20 text-ink">
      {/* Hero Section */}
      <section className="relative overflow-hidden border-b border-primary/10 py-10">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('${process.env.PUBLIC_URL}/Contact.png')`,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/65 to-black/55" />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-transparent to-primary/10" />
        
        <div className="relative mx-auto flex max-w-6xl flex-col items-center gap-6 px-4 py-20 text-center lg:px-6">
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-r from-primary/30 to-primary-soft/30 rounded-full blur-2xl animate-pulse" />
            <h1 className="relative text-5xl font-semibold sm:text-6xl text-white pb-2 drop-shadow-lg">
              Get in Touch
            </h1>
          </div>
          <p className="max-w-3xl text-lg leading-relaxed text-white/90 sm:text-xl drop-shadow-md">
            We are excited to connect with you. Share your goals and our
            advisors will design the right language journey.
          </p>
        </div>
      </section>

      {/* Contact Form & Info Section */}
      <section className="py-20 bg-white">
        <div className="mx-auto max-w-6xl px-4 lg:px-6">
          <div className="grid lg:grid-cols-2 gap-8 items-start">
            {/* Contact Form */}
            <div className="rounded-3xl border border-primary/10 bg-gradient-to-br from-primary/5 via-white to-white/80 p-8 shadow-[0_28px_60px_rgba(15,23,42,0.18)]">
              <h2 className="text-2xl font-semibold mb-4">Send us a Message</h2>
              <p className="text-sm text-ink-muted mb-6">
                Fill out the form below and we'll get back to you within 24
                hours
              </p>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-ink mb-2"
                  >
                    Name <span className="text-red-500">*</span>
                  </label>
                  <div className="relative flex items-center rounded-lg border border-primary/20 bg-white focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20">
                    <FaUser className="ml-4 text-primary" />
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full rounded-lg border-0 bg-transparent px-3 py-3 text-sm text-ink placeholder:text-ink-muted/60 focus:outline-none"
                      placeholder="Your full name"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-ink mb-2"
                  >
                    Email <span className="text-red-500">*</span>
                  </label>
                  <div className="relative flex items-center rounded-lg border border-primary/20 bg-white focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20">
                    <FaEnvelope className="ml-4 text-primary" />
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full rounded-lg border-0 bg-transparent px-3 py-3 text-sm text-ink placeholder:text-ink-muted/60 focus:outline-none"
                      placeholder="your.email@example.com"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium text-ink mb-2"
                  >
                    Phone
                  </label>
                  <div className="relative flex items-center rounded-lg border border-primary/20 bg-white focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20">
                    <FaPhoneAlt className="ml-4 text-primary" />
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full rounded-lg border-0 bg-transparent px-3 py-3 text-sm text-ink placeholder:text-ink-muted/60 focus:outline-none"
                      placeholder="+91 90000 00000"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="message"
                    className="block text-sm font-medium text-ink mb-2"
                  >
                    Message <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    required
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full rounded-lg border border-primary/20 bg-white px-4 py-3 text-sm text-ink placeholder:text-ink-muted/60 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
                    placeholder="Tell us about your language learning goals, questions, or how we can help you..."
                  />
                </div>

                <button
                  type="submit"
                  className="w-full rounded-full bg-gradient-to-r from-primary to-primary-soft px-8 py-3 text-sm font-semibold uppercase tracking-wide text-white shadow-[0_18px_30px_rgba(79,64,198,0.35)] transition hover:-translate-y-1 hover:shadow-[0_24px_40px_rgba(18,10,56,0.35)] flex items-center justify-center gap-2"
                >
                  <FaPaperPlane />
                  Send Message
                </button>
              </form>
            </div>

            {/* Contact Info & Map */}
            <div className="flex flex-col gap-6 h-full">
              {/* Institute Address with Map */}
              <div className="rounded-3xl border border-primary/10 bg-white p-6 shadow-elevated flex-1 flex flex-col">
                <div className="flex items-start gap-4 mb-6">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary/10 to-primary-soft/10 text-xl text-primary flex-shrink-0">
                    <FaMapMarkerAlt />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-ink mb-2">
                      Institute Address
                    </h3>
                    <p className="text-sm text-ink-muted leading-relaxed">
                      21/7 Language Park Avenue
                      <br />
                      Pune, Maharashtra 411001
                      <br />
                      India
                    </p>
                  </div>
                </div>
                {/* Google Map Embed - Pune Location */}
                <div className="rounded-xl overflow-hidden border border-primary/10 aspect-video flex-1 min-h-[300px]">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.0!2d73.8567!3d18.5204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf2e67461101%3A0x828d43bf9d9ee343!2sPune%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="w-full h-full"
                    title="The Lingua Alliance - Pune Location"
                  ></iframe>
                </div>
              </div>

              {/* Working Hours */}
              <div className="rounded-3xl border border-primary/10 bg-white p-6 shadow-elevated">
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary/10 to-primary-soft/10 text-xl text-primary flex-shrink-0">
                    <FaClock />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-ink mb-4">
                      Working Hours
                    </h3>
                    <div className="space-y-3 text-sm text-ink-muted">
                      <div className="flex justify-between items-center">
                        <span className="font-medium text-ink">
                          Monday - Friday
                        </span>
                        <span>09:00 - 19:00 IST</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="font-medium text-ink">Saturday</span>
                        <span>10:00 - 16:00 IST</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="font-medium text-ink">Sunday</span>
                        <span className="text-ink-muted">Closed</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Contact Section - Full Width */}
          <div className="mt-8 rounded-3xl border border-primary/10 bg-gradient-to-br from-primary to-primary-soft p-8 shadow-elevated text-white">
            <h3 className="text-2xl font-semibold mb-8 text-center">
              Quick Contact
            </h3>
            <div className="flex items-center justify-center gap-10">
              <div className="flex flex-col gap-6 mb-8">
                <div className="flex items-center gap-4">
                  <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-white/20 text-2xl flex-shrink-0">
                    <FaEnvelope />
                  </div>
                  <div className="text-left">
                    <p className="text-sm text-white/80 mb-1">Email</p>
                    <p className="text-base font-medium">
                      hello@thelinguaalliance.com
                    </p>
                    <p className="text-sm text-white/70">
                      support@thelinguaalliance.com
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-white/20 text-2xl flex-shrink-0">
                    <FaPhoneAlt />
                  </div>
                  <div className="text-left">
                    <p className="text-sm text-white/80 mb-1">Phone</p>
                    <p className="text-base font-medium">+91 999 999 9999</p>
                    <p className="text-sm text-white/70">+91 888 888 8888</p>
                  </div>
                </div>
              </div>

              {/* WhatsApp & Call Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="https://wa.me/919999999999"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 rounded-full bg-white text-primary px-8 py-3 text-sm font-semibold transition hover:bg-white/90 shadow-lg"
                >
                  <FaWhatsapp className="text-lg" />
                  Chat on WhatsApp
                </a>
                <a
                  href="tel:+919999999999"
                  className="flex items-center justify-center gap-2 rounded-full bg-white/10 border-2 border-white text-white px-8 py-3 text-sm font-semibold transition hover:bg-white/20"
                >
                  <FaPhoneAlt />
                  Call Us Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
